/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');

var SideNavSectionView = require('common/views/SideNavSectionView');
var switchToPrint = require('common/util/switchToPrint');

var PawnbrokerAnnualReportGeneralDetailsSectionView = require('./PawnbrokerAnnualReportGeneralDetailsSectionView');
var PawnbrokerAnnualReportFinancialStatementsSectionView = require('./PawnbrokerAnnualReportFinancialStatementsSectionView');
var PawnbrokerAnnualReportProductionReportSectionView = require('./PawnbrokerAnnualReportProductionReportSectionView');
var PawnbrokerAnnualReportAffirmationSectionView = require('./PawnbrokerAnnualReportAffirmationSectionView');
var SubmitPawnbrokerAnnualReport = require('../../services/SubmitPawnbrokerAnnualReport');

var tmplPawnbrokerAnnualReportView = require('./PawnbrokerAnnualReportView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplPawnbrokerAnnualReportView,

  className: 'pawnbroker-annual-report-view m-b-md',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    pawnbrokerAnnualReportContainer: '.pawnbroker-annual-report-container'
  },

  regions: {
    pawnbrokerAnnualReportContainer: '@ui.pawnbrokerAnnualReportContainer'
  },

  onBeforeShow: function() {
    var mode = this.options.mode;
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';

    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'pawnbrokerAnnualReportGeneralDetails',
          title: 'General Details',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new PawnbrokerAnnualReportGeneralDetailsSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'pawnbrokerAnnualReportFinancialStatements',
          title: 'Financial Statements',
          view: new PawnbrokerAnnualReportFinancialStatementsSectionView({
            isReadOnly: this.options.isReadOnly
          })
        },
        {
          id: 'pawnbrokerAnnualReportProductionReport',
          title: 'Production Report',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new PawnbrokerAnnualReportProductionReportSectionView({
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'pawnbrokerAnnualReportAffirmation',
          title: 'Affirmation',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new PawnbrokerAnnualReportAffirmationSectionView({
            isReadOnly: this.options.isReadOnly,
            mode: this.options.mode,
            model: this.model
          })
        }
      ]),
      useNavigationButtons: !this.options.isReadOnly,
      contentWidth: 'medium',
      expanded: isForPrinting || isExpandInternal,
      buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        }
      ]
    });

    if (
      this.options.isReadOnly &&
      !(this.options.mode === 'print' || this.options.mode === 'int' || this.options.mode === 'int-expand')
    ) {
      this.form.collection.remove(this.form.collection.get('pawnbrokerAnnualReportAffirmation'));
    }

    this.showChildView('pawnbrokerAnnualReportContainer', this.form);
  },

  onClickSave: function(e) {
    e.preventDefault();
    var self = this;
    self.form.validateAll({ type: 'save' }).done(function() {
      var l = Ladda.create(e.currentTarget);
      l.start();
      var rawFormData = self.form.getFormData();
      var formData = {
        applicationId: self.model.get('applicationId'),
        annualReportId: self.model.get('annualReportId'),
        generalDetails: rawFormData.pawnbrokerAnnualReportGeneralDetails,
        productionReport: rawFormData.pawnbrokerAnnualReportProductionReport,
        affirmation: rawFormData.pawnbrokerAnnualReportAffirmation
      };
      SubmitPawnbrokerAnnualReport(formData)
        .done(function() {
          l.stop();
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  onAttach: function() {
    if (this.options.mode === 'print') {
      switchToPrint(this.$el, '.input-view');
    }
  }
});
